import { RootState } from '..';

export const selectLocale = (state: RootState) => state.ui.locale;
